import React from "react";
import MasterLayout from "../../../masterLayout/MasterLayout";
import { Breadcrumb } from "react-bootstrap";
import BookingApprove from "../BookingApprove";

const UpcomingBooking = () => {
  return (
    <MasterLayout>
      {/* Breadcrumb */}
      <Breadcrumb title="Upcoming Bookings" />
      <BookingApprove status={4} />
    </MasterLayout>
  );
};

export default UpcomingBooking;
